import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface EmptyStateProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, actions, children, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex min-h-24 flex-col items-center justify-center gap-2 rounded-md border border-dashed px-6 py-8 text-center text-sm text-muted-foreground",
        className,
      )}
    >
      {title ? <p className="font-medium text-foreground">{title}</p> : null}
      {description ? <p>{description}</p> : null}
      {children}
      {actions ? (
        <div className="mt-1 flex flex-wrap items-center justify-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}
